/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 17:58:17
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { FormLayout, Stack, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { RenderLabelTooltip } from 'src/components/views/common/forms/render-label-tooltip';

type Props = {
  themeSetupV2: boolean,
  clearCache: Function,
  loadingClearCache: boolean
};

type ComposedProps = Props & WithI18nProps;

class FilterTab extends Component<ComposedProps> {
  render() {
    const { themeSetupV2, clearCache, loadingClearCache, i18n } = this.props;
    return (
      <FormLayout>
        <Stack distribution="fill">
          <FormLayout>
            <Field
              name="displaySetting.showFilterOptionCount"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field1_Label')}
              tooltip={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field1_Tooltip')}
            />
            <Field
              name="displaySetting.showRefineBy"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field2_Label')}
            />
            <Field
              name="displaySetting.showOutOfStockOption"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field3_Label')}
              tooltip={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field3_Tooltip')}
            />
            {themeSetupV2 && (
              <Field
                name="displaySetting.shortenURL"
                component={RenderCheckbox}
                label={i18n.translate(
                  'AdminHTML.FilterSettings.Display.filterTab_FieldShortenURL_Label'
                )}
                tooltip={i18n.translate(
                  'AdminHTML.FilterSettings.Display.filterTab_FieldShortenURL_Tooltip',
                  {
                    nt_link1: (
                      <i>
                        https://demo.myshopify.com/collections/top?pf_v_vendor=Burberry&pf_v_vendor=Converse'
                      </i>
                    ),
                    nt_link2: (
                      <i>https://demo.myshopify.com/collections/top?vendor=Burberry,Converse</i>
                    )
                  }
                )}
              />
            )}
          </FormLayout>
          <FormLayout>
            <Field
              name="displaySetting.showSingleOption"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field4_Label')}
              tooltip={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field4_Tooltip')}
            />
            <Field
              name="displaySetting.keepToggleState"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field5_Label')}
              tooltip={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field5_Tooltip')}
            />
            <Field
              name="displaySetting.changeMobileButtonLabel"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.filterTab_Field6_Label')}
            />
          </FormLayout>
        </Stack>
        <div className="BC-Button-ClearCache">
          <RenderLabelTooltip
            label={i18n.translate(
              'AdminHTML.FilterSettings.Display.filterTab_RenderLabelTooltip_Label'
            )}
            tooltip={i18n.translate(
              'AdminHTML.FilterSettings.Display.filterTab_RenderLabelTooltip_ToolTip'
            )}
          />
          <Button primary onClick={clearCache} loading={loadingClearCache}>
            {i18n.translate('AdminHTML.FilterSettings.Display.filterTab_buttonText')}
          </Button>
        </div>
      </FormLayout>
    );
  }
}
export default withI18n()(FilterTab);
